<template>
  <section>
    <div class="head">
      <div class="title">
        <h6>Delete Message</h6>
      </div>
      <div class="actions">
        <button class="icon" @click="$emit('close')" aria-label="Close">
          <fa-icon
            :icon="['fas', 'times']"
            size="lg"
          />
        </button>
      </div>
    </div>
    <div class="body">
      <p>Are you sure you want to delete this message? This cannot be undone.</p>
    </div>
    <div class="foot">
      <button class="close" @click="$emit('close')" aria-label="Cancel">Cancel</button>
      <button class="error" @click="deleteMessage" aria-label="Delete">Delete</button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DeleteMessageModal',
  props: [
    'messageId',
    'channelId'
  ],
  methods: {
    ...mapActions([
      'removeMessage'
    ]),
    async deleteMessage() {
      try {
        await this.removeMessage({ 
          messageId: this.messageId,
          channelId: this.channelId
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Message Deletion',
          text: 'The message has been successfully deleted.'
        });
      } catch (e) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Message Deletion',
          text: 'Unable to delete message.'
        });
      }
      this.$emit('close');
    }
  }
}
</script>

<style scoped lang="scss">
section {
  font-family: Poppins, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(47, 49, 56);
  padding: 16px;
}

.head {
  display: table;
  width: 100%;
  padding: 0 0 10px 0;

  .title {
    display: table-cell;
    vertical-align: middle;

    > * {
      margin: 0;
    }
  }

  .actions {
    width: 1px;
    display: table-cell;
  }
}

.foot {
  text-align: right;
}

h6 {
  font-size: 13.6px;
}

p {
  font-size: 16px;
  margin: 0;
}

button.icon {
  width: 30px;
  height: 30px;
  font-size: 11px;
  border-radius: 4px;
  border: 0;
  padding: 0;
  background: none;
  color: rgba(47, 49, 56, 0.6);
  cursor: pointer;
  transition: background 250ms ease-out,
    color 250ms ease-out;

  &:focus {
    outline: none;
    box-shadow: none;
    background: none;
    color: rgba(47, 49, 56, 0.6);
  }

  &.selected,
  &:hover {
    background: rgba(234, 235, 239, 0.5);
    color: rgb(47, 49, 56);
  }
}

button.close,
button.error {
  margin: 14px 0 0 0;
  font-size: 16px;
  font-family: "Poppins";
  text-align: center;
  height: 40px;
  padding: 0 15px;
  color: #fff;
  box-sizing: border-box;
  border-radius: 4px;
  border: 0;
  background: #E54D42;
  cursor: pointer;
  transition: background 250ms ease-out;

  &:hover {
    background-color: rgba(229,77,66,0.8);
  }
}

button.close {
  background: none;
  color: rgb(47, 49, 56);
  margin-right: 10px;

  &:hover {
    background: rgba(234, 235, 239, 0.5);
  }
}
</style>
